/**
 * Per-doc metadata injected by the worker into the SPA shell (`#doc-meta`).
 *
 * The public bundle only carries listed entries (see `public-manifest.ts`), so this is the
 * fallback that lets an unlisted link opened directly render without shipping the full manifest
 * to every visitor. Works only on worker-served pages (`/d/*`, `/p/*`); under `vite dev` the
 * public manifest is the sole source.
 */
export const injectedDocMeta = <T extends { slug: string }>(slug: string): T | undefined => {
  const script = document.getElementById("doc-meta");

  if (!script?.textContent) return undefined;

  try {
    const meta = JSON.parse(script.textContent) as T;

    return meta.slug === slug ? meta : undefined;
  } catch {
    return undefined;
  }
};
